<template>
  <div class="modal-message"><slot /></div>
</template>

<script>
export default {
  name: "ModalMessage"
};
</script>

<style lang="scss">
.modal-message {
  color: colors(text-2);
  text-align: center;
  min-height: calc(30px + 1.15em);
  padding: 15px 0;
}
</style>
